<router-outlet ></router-outlet>
<app-chalisa-list></app-chalisa-list>